import { AxiosResponse } from 'axios'
import client from './client'

const getChatList = (params: { per_page: number }) => async (authHeaders: any) => {
  const response = await client.request<AxiosResponse>({
    method: 'GET',
    url: `/chat/get-history`,
    headers: authHeaders,
    params,
  })

  return response.data.data
}

const createMessageChat = (data: { message: string }) => async (authHeaders: any) => {
  const response = await client.request<AxiosResponse>({
    method: 'POST',
    url: `/chat/push-message`,
    headers: authHeaders,
    data,
  })

  return response.data.data
}
export default { createMessageChat, getChatList }
